import { CurrentReservationService } from '@/common/services/reservation/current';
import { ValidationService } from '@/common/services/validation/validation.service';
import { fromJSDateToInputDate } from '@/common/utils/date/fromJSDateToInputDate';
import { BranchParams } from '@/core/domain/branches/models/branch.model';
import { FindBranchesUseCase } from '@/core/domain/branches/usecases/findBranches.usecase';
import { isValid } from '@/common/utils/validation/common.utils';
import { FindLocationsUseCase } from '@/core/domain/locations/usecases/findLocations.usecase';
import { ClearReservationUseCase } from '@/core/domain/reservation/usecases/clearReservation.usecase';
import { SaveReservationUseCase } from '@/core/domain/reservation/usecases/saveReservation.usecase';
import { saveDifferentLocations } from '@/core/reservation/store/differentLocations.actions';
import { saveEndHours } from '@/core/reservation/store/end-hours.actions';
import { saveLocations } from '@/core/reservation/store/locations.actions';
import { saveStartHours } from '@/core/reservation/store/start-hours.actions';
import { InputComponent } from '@/ui/shared/ui/input/input.component';
import { HttpClient } from '@angular/common/http';
import {
    Component,
    Inject,
    makeStateKey,
    OnInit,
    TransferState,
    ViewChild,
    ViewEncapsulation,
} from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import _ from 'lodash';
import { Observable, of, skip, switchMap, take } from 'rxjs';
import { saveVehicles } from '@/core/reservation/store/vehicles.actions';
import { FindSchedulesUseCase } from '@/core/domain/locations/usecases/findSchedules.usecase';
import { fromJSDateToISODate } from '@/common/utils/date/fromJSDateToISODate';
import { BranchIntParams } from '@/core/domain/branches-international/models/branch-international.model';
import { FindBranchesInternationalUseCase } from '@/core/domain/branches-international/usecases/findBranchesInternational.usecase';
import { GetAvailabilityInternationalUseCase } from '@/core/domain/branches-international/usecases/getAvailabilityInternational.usecase';
import { SaveLocationIntUseCase } from '@/core/domain/branches-international/usecases/saveLocationInt.usecase';
import { saveLocationInt } from '@/core/international/store/international.actions';
import { ClearLocationIntUseCase } from '@/core/domain/branches-international/usecases/clearLocationInt.usecase';
import { Location } from '@/core/domain/locations/models/location.model';
import { Meta, Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { SsrService } from '@/common/services/ssr/ssr.service';

const TITLE_KEY = makeStateKey<string>('page-title');

@Component({
    selector: 'fe-step-1',
    templateUrl: './step-1.component.html',
    styleUrls: ['./step-1.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class Step1Component implements OnInit {
    public form!: FormGroup;

    public startDate: Date | null = null;

    public endDate: Date | null = null;

    public discountCode = null;

    @ViewChild('inputLocation') inputLocation!: InputComponent;
    @ViewChild('inputDifferentLocation')
    inputDifferentLocation!: InputComponent;
    @ViewChild('inputStartDate') inputStartDate!: InputComponent;
    @ViewChild('inputStartHour') inputStartHour!: InputComponent;
    @ViewChild('inputEndDate') inputEndDate!: InputComponent;
    @ViewChild('inputEndHour') inputEndHour!: InputComponent;
    @ViewChild('inputAge') inputAge!: InputComponent;
    FindBranchesUseCase: any;

    public textNotFoundLocations: string | null = null;
    public textNotFoundDifferentLocations: string | null = null;

    public loadingLocations = false;

    public loadingDifferentLocations = false;

    public loadingHours = false;

    constructor(
        private readonly formBuilder: FormBuilder,
        private readonly findLocationsUseCase: FindLocationsUseCase,
        private readonly findbranchesUseCase: FindBranchesUseCase,
        private readonly httpClient: HttpClient,
        private readonly store: Store,
        private readonly router: Router,
        private readonly validation: ValidationService,
        public reservation: CurrentReservationService,
        private readonly saveReservationUseCase: SaveReservationUseCase,
        private readonly clearReservationUseCase: ClearReservationUseCase,
        private readonly findSchedulesUseCase: FindSchedulesUseCase,
        private readonly findBranchesInternationalUseCase: FindBranchesInternationalUseCase,
        private readonly getAvailabilityInternational: GetAvailabilityInternationalUseCase,
        private readonly saveLocationIntUseCase: SaveLocationIntUseCase,
        private readonly clearLocationIntUseCase: ClearLocationIntUseCase,
        private titleService: Title,
        private metaService: Meta,
        private translateService: TranslateService,
        // private transferState: TransferState,
        // private ssr: SsrService,
        @Inject('INPUT_DATEPICKER') public inputDatePickerFormat: string,
    ) {
        this.initForm();
        this.initReservation();
    }

    public ngOnInit(): void {
        this.reset();
    }

    private reset(): void {
        this.reservation.current.differentLocation = [];
        this.reservation.current.location = [];
        this.reservation.current.discountCode = null;
        this.reservation.current.endDate = null;
        this.reservation.current.endHour = null;
        this.reservation.current.startDate = null;
        this.reservation.current.startHour = null;
        this.reservation.locations = [];
        this.reservation.showDifferenteLocation = false;
        this.form.reset();
    }

    private initForm(): void {
        this.form = this.formBuilder.group(
            {
                location: [[], Validators.compose([Validators.required])],
                differentLocation: [
                    '',
                    Validators.compose([Validators.required]),
                ],
                startDate: ['', Validators.compose([Validators.required])],
                startHour: ['', Validators.compose([Validators.required])],
                endDate: ['', Validators.compose([Validators.required])],
                endHour: ['', Validators.compose([Validators.required])],
                age: ['', Validators.compose([Validators.required])],
            },
            {
                validators: [
                    this.validation.mismatchingControls(
                        'location',
                        'differentLocation',
                    ),
                    this.validation.maxDifferenceDates(
                        'startDate',
                        'endDate',
                        31,
                    ),
                    this.validation.isGreaterThanDatetime(
                        'startDate',
                        'startHour',
                        'endDate',
                        'endHour',
                    ),
                ],
            },
        );
    }

    private initReservation(): void {
        this.clearReservationUseCase.execute().subscribe();
    }

    public onClickBtnAfter(event: any): void {
        this.reservation.showDifferenteLocation =
            !this.reservation.showDifferenteLocation;
        this.reservation.current.differentLocation = null;
        this.toggleSelectLocations();
    }

    protected toggleSelectLocations(): void {
        if (this.reservation.showDifferenteLocation) {
            setTimeout(() => {
                this.inputDifferentLocation.getSelectComponent().open();
            });
            return;
        }
        this.reservation.differentLocations = [];
    }

    public onChangeLocation(): void {
        this.checkeLocationDates();
    }

    public onSearchLocations(term: string): void {
        this.loadingLocations = true;
        this.findLocationsUseCase
            .execute({ searchTerm: term })
            .subscribe((locations) => {
                this.loadingLocations = false;
                this.reservation.locations = locations.data as {
                    [key: string]: unknown;
                }[];
                this.checkTextLabelLocations(term);
                this.store.dispatch(
                    saveLocations({ value: this.reservation.locations }),
                );
            });
    }

    private checkTextLabelLocations(term: string): void {
        this.textNotFoundLocations =
            term.length >= 3 && this.reservation.locations.length === 0
                ? 'No se han obtenido resultados'
                : null;
    }

    public onSearchDifferentLocations(term: string): void {
        this.loadingDifferentLocations = true;
        const locationId = _.first(this.reservation.current.location);
        this.findLocationsUseCase
            .execute({
                searchTerm: term,
                isPickupInternational: _.some(
                    this.reservation.locations,
                    (item: Location) =>
                        item.id === locationId && item.location === 'INT',
                ),
                isReturn: true,
                pickupLocationId: locationId,
            })
            .subscribe((locations) => {
                this.loadingDifferentLocations = false;
                this.reservation.differentLocations = locations.data as {
                    [key: string]: unknown;
                }[];
                this.checkTextLabelDifferentLocations(term);
                this.store.dispatch(
                    saveDifferentLocations({
                        value: this.reservation.differentLocations,
                    }),
                );
            });
    }

    private checkTextLabelDifferentLocations(term: string): void {
        this.textNotFoundDifferentLocations =
            term.length >= 3 && this.reservation.differentLocations.length === 0
                ? 'No se han obtenido resultados'
                : null;
    }

    public onSelectedDateStart(date: any): void {
        this.setDates(date);
    }

    public onSelectedDateEnd(date: any): void {
        this.setDates(date);
    }

    private setDates(date: any): void {
        this.startDate = date.start;
        this.endDate = date.end;
        this.reservation.current.startDate = fromJSDateToInputDate(date.start);
        this.reservation.current.endDate = fromJSDateToInputDate(date.end);
        this.checkeLocationDates();
    }

    protected checkeLocationDates(): void {
        if (
            isValid(this.reservation.current.location) &&
            isValid(this.reservation.current.startDate) &&
            !this.form.hasError('differenceDatesOut') &&
            !this.form.hasError('lessThanDate')
        ) {
            this.findHours();
        } else {
            this.resetHours();
        }
    }

    private resetHours(): void {
        this.reservation.current.startHour = null;
        this.reservation.current.endHour = null;
        this.reservation.startHours = [];
        this.reservation.endHours = [];
    }

    protected findHours(): void {
        this.loadingHours = true;

        const branch = _.find(
            this.reservation.locations,
            (item) => item.id === _.first(this.reservation.current.location),
        );
        const typeReservation = branch.location == 'INT' ? 'INT' : 'NAT';
        this.findSchedulesUseCase
            .execute({
                id: _.first(this.reservation.current.location) as string,
                location: typeReservation,
                pickup: fromJSDateToISODate(this.startDate as Date),
                return: fromJSDateToISODate(this.endDate as Date),
            })
            .pipe(
                switchMap((schedulesResponse) => {
                    this.onGetSchedules(schedulesResponse);
                    return of(schedulesResponse);
                }),
            )
            .subscribe();
    }

    private onGetSchedules(hours: any): void {
        this.loadingHours = false;
        this.reservation.startHours = _.get(hours, 'data.schedules.pickup', []);
        if (!isValid(this.reservation.current.discountCode)) {
            this.reservation.current.discountCode = _.get(
                hours,
                'data.coupons.0',
                '',
            );
        }
        // eslint-disable-next-line @ngrx/avoid-dispatching-multiple-actions-sequentially
        this.store.dispatch(
            saveStartHours({ value: this.reservation.startHours }),
        );
        this.reservation.endHours = _.get(hours, 'data.schedules.return', []);
        // eslint-disable-next-line @ngrx/avoid-dispatching-multiple-actions-sequentially
        this.store.dispatch(saveEndHours({ value: this.reservation.endHours }));
    }

    private focusToInvalid(): void {
        if (this.form.get('location')?.invalid) {
            this.inputLocation.focus();
            return;
        }
        if (
            this.reservation.showDifferenteLocation &&
            this.form.get('differentLocation')?.invalid
        ) {
            this.inputDifferentLocation.focus();
            return;
        }
        if (this.form.get('startDate')?.invalid) {
            this.inputStartDate.focus();
            return;
        }
        if (this.form.get('startHour')?.invalid) {
            this.inputStartHour.focus();
            return;
        }
        if (this.form.get('endDate')?.invalid) {
            this.inputEndDate.focus();
            return;
        }
        if (this.form.get('endHour')?.invalid) {
            this.inputEndHour.focus();
            return;
        }
        if (this.form.get('age')?.invalid) {
            this.inputAge.focus();
            return;
        }
    }

    public onClickSearch(): void {
        this.form.markAllAsTouched();

        if (!this.reservation.showDifferenteLocation) {
            this.form.get('differentLocation')?.setErrors(null);
        }

        if (!this.form.valid) {
            this.focusToInvalid();
            return;
        }
        const branch = _.find(
            this.reservation.locations,
            (item) => item.id === _.first(this.reservation.current.location),
        );

        const locationInfo: BranchParams = {
            id_sucursal_renta: _.first(this.reservation.current.location),
            id_sucursal_devolucion: _.first(
                this.reservation.current.differentLocation,
            ),
            fRenta: this.reservation.current.startDate,
            hRenta: this.reservation.current.startHour,
            fDevolucion: this.reservation.current.endDate,
            hDevolucion: this.reservation.current.endHour,
        };

        const locationInt: BranchIntParams = {
            id: _.first(this.reservation.current.location),
            location: branch.location,
            fRenta: this.reservation.current.startDate,
            hRenta: this.reservation.current.startHour,
            fDevolucion: this.reservation.current.endDate,
            hDevolucion: this.reservation.current.endHour,
            type: branch.group,
        };

        const branchIntParams: BranchIntParams = {
            id: _.first(this.reservation.current.location),
            location: branch.location,
            lat: branch.gps.latitude,
            lon: branch.gps.longitude,
            fRenta: this.reservation.current.startDate,
            hRenta: this.reservation.current.startHour,
            fDevolucion: this.reservation.current.endDate,
            hDevolucion: this.reservation.current.endHour,
            type: branch.group,
        };

        this.clearLocationIntUseCase.execute();

        if (branch.location === 'INT') {
            if (branch.group === 'city') {
                this.store.dispatch(
                    saveLocationInt({
                        value: branchIntParams,
                    }),
                );
                this.router.navigate([
                    'es',
                    'reservaciones-internacionales',
                    'busqueda-sucursales',
                ]);
                return;
            } else {
                this.getAvailabilityInternational
                    .execute(locationInt)
                    .subscribe((locations) => {
                        this.saveReservationUseCase.execute().subscribe();
                        this.store.dispatch(
                            saveVehicles({ value: locations.data }),
                        );
                        this.router.navigate(
                            ['es', 'reservaciones', 'categorias-y-vehiculos'],
                            {
                                state: {
                                    international: true,
                                },
                            },
                        );
                    });
                return;
            }
        }

        this.findbranchesUseCase
            .execute(locationInfo)
            .subscribe((locations) => {
                this.saveReservationUseCase.execute().subscribe();
                this.store.dispatch(saveVehicles({ value: locations.data }));
                this.router.navigate([
                    'es',
                    'reservaciones',
                    'categorias-y-vehiculos',
                ]);
            });
    }

    public onPromoApplied(code: string): void {
        this.reservation.current.discountCode = code;
    }
}
